module.exports = __webpack_public_path__ + "645893abe9a71b651c2a9c1f57b8bbd8.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/telescope-s.png
// module id = 1948
// module chunks = 0